import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import SfpBaseService from './sfp-base-service';

const PPI_EXPENSES = 'ppis/expenses';

export default class PPIExpenseService extends SfpBaseService {

  static createPPIExpense(ppi_expense) {
    const body = JSON.stringify({ppi_expense});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${PPI_EXPENSES}`, {body, headers, method: "POST"})
      .then(super.returnResponse);
  }

  static updatePPIExpense(ppi_expense_id, ppi_expense) {
    const body = JSON.stringify({ppi_expense});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_expense_id}/expense`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
  }

  static deletePPIExpense(ppi_expense) {
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_expense.id}/expense`, {headers, method: "DELETE"})
      .then(super.returnResponse);
  }

}



// WEBPACK FOOTER //
// ./src/service/sfp/ppi-expense-service.js